/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Menu from 'components/Menu.jsx';
import MenuButton from 'components/MenuButton.jsx';
import MenuItem from 'components/MenuItem.jsx';
import { mountModal } from 'lib/modal.js';
import ProfilePicture from 'user/components/ProfilePicture.jsx';
import React from 'react';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import Text from 'components/Text.jsx';

import './styles/UserParentChildRow.scss';

type MinimalRelatedUser = {
  id: number,
  name: string,
}

type Props = {
  relation: 'parent' | 'child',
  related_user: MinimalRelatedUser,
  pending?: boolean,
};

class UserParentChildRow extends React.Component {
  props: Props;
  state = {};

  confirmRemoveRelation = () => {
    const modal = (
      <ConfirmDialog
        title={`Are you sure you want to remove ${this.props.related_user.name} as your ${this.props.relation}?`}
      />
    );
    mountModal(modal, this);
  }

  goToProfile = () => {
    const modal = <RelationshipModal userId={this.props.related_user.id} />;
    mountModal(modal, this);
  }

  renderMenu() {
    const removeText = this.props.relation === 'parent' ? 'Remove parent' : 'Remove child';
    return (
      <Menu>
        <MenuItem onClick={this.goToProfile}>
          <Glyph name="avatar" />
          View profile
        </MenuItem>
        <MenuItem onClick={this.confirmRemoveRelation}>
          <Glyph name="close" />
          {removeText}
        </MenuItem>
      </Menu>
    );
  }

  render = () => {
    const textColor = this.props.pending ? 'koala' : undefined;

    return (
      <tr className="UserParentChildRow">
        <td>
          <MediaObject gutter="small" className="UserParentChildRow-name">
            <div>
              <ProfilePicture
                size="medium"
                user={this.props.related_user}
              />
            </div>
            <div className="UserParentChildRow-name-text">
              <Text element="div" color={textColor}>
                {this.props.related_user.name}
              </Text>
              {this.props.pending && <Text element="div" color={textColor}>Pending</Text>}
            </div>
          </MediaObject>
        </td>
        <td>
          <MenuButton
            alignment="right"
            placement="bottom"
            menu={this.renderMenu()}
            size="small"
            level="icon">
            <Glyph name="ellipses" solo />
          </MenuButton>
        </td>
      </tr>
    );
  }
}

export default UserParentChildRow;



// WEBPACK FOOTER //
// ./src/settings/components/UserParentChildRow.jsx